// import './inner_navigation.js';
document.addEventListener('DOMContentLoaded', function() {
    const calendars = document.querySelectorAll('.akbn_calendar');
    const prevCalButton = document.getElementById('prevCalButton');
    const nextCalButton = document.getElementById('nextCalButton');
    console.log(calendars)

    let currentIndex = 0;
    // カレンダーとボタンの状態を更新する関数
    function updateCalendars() {
        calendars.forEach((cal, i) => {
            if (i === currentIndex) {
                cal.classList.remove('deactivated');
            } else {
                cal.classList.add('deactivated');
            }
        });
        // 先頭なら「戻る」ボタンを無効、末端なら「進む」ボタンを無効にする
        prevCalButton.disabled = (currentIndex === 0);
        nextCalButton.disabled = (currentIndex === calendars.length - 1);
        console.log(currentIndex)
    }

    updateCalendars();

    prevCalButton.addEventListener('click', () => {
        console.log('prev button click')
        if (currentIndex > 0) {
            currentIndex--;
            updateCalendars();
        }
    })
    nextCalButton.addEventListener('click', () => {
        console.log('next button click')
        if (currentIndex < calendars.length - 1) {
            currentIndex++;
            updateCalendars();
        }
    })
})